import {useTranslation} from 'react-i18next';
import {useCallback, useState, useEffect} from 'react';
import {Callback, TFunction} from 'i18next';

export function useLocalization(ns: string[] = []) {
    const {t, i18n} = useTranslation(ns);
    const [currentLanguage, setCurrentLanguage] = useState<string|null>(i18n.language);

    useEffect(() => {
        setCurrentLanguage(i18n.language);
    }, [i18n.language]);

    const changeLanguage = useCallback((lng?: string, callback?: Callback) => {
        if (lng && lng !== currentLanguage) setCurrentLanguage(lng);
        return i18n.changeLanguage(lng, callback);
    }, [i18n, currentLanguage]);

    const rawT = useCallback((key: string, ...params) => {
        if (!key || currentLanguage == null) return '';
        return t(key.toString().toLowerCase(), ...params);
    }, [t, currentLanguage]);

    return {t: rawT as TFunction, changeLanguage, currentLanguage};
}